var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegracao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.7803 2.21967C18.0732 2.51256 18.0732 2.98744 17.7803 3.28033L16.3347 4.72592C17.4087 6.29705 17.2483 8.4587 15.8536 9.85344L15.5536 10.1534L15.5511 10.1559L15.2425 10.4646C14.8324 10.8746 14.1676 10.8746 13.7576 10.4646L9.53534 6.24233C9.1253 5.83229 9.1253 5.16749 9.53534 4.75745L10.1465 4.14634C10.3208 3.97199 10.5071 3.81693 10.7028 3.68116C12.0724 2.73076 13.8994 2.72545 15.2741 3.66524L16.7197 2.21967C17.0126 1.92678 17.4874 1.92678 17.7803 2.21967Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.78033 8.46967C9.07322 8.76256 9.07322 9.23744 8.78033 9.53033L7.50884 10.8018L9.19818 12.4912L10.4697 11.2197C10.7626 10.9268 11.2374 10.9268 11.5303 11.2197C11.8232 11.5126 11.8232 11.9874 11.5303 12.2803L10.2536 13.557C10.7333 14.1423 10.6999 15.0073 10.1536 15.5537L9.85357 15.8537C8.45879 17.2484 6.29705 17.4088 4.72591 16.3348L3.28033 17.7803C2.98744 18.0732 2.51256 18.0732 2.21967 17.7803C1.92678 17.4874 1.92678 17.0126 2.21967 16.7197L3.66527 15.2741C2.59133 13.7029 2.75172 11.5413 4.14646 10.1466L4.44646 9.84655C4.99275 9.30026 5.85772 9.26686 6.44297 9.74637L7.71967 8.46967C8.01256 8.17678 8.48744 8.17678 8.78033 8.46967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegracao);
export default __webpack_public_path__ + "static/media/integracao.16c0f6a0e8c701bc3ae7f3ca9d69c964.svg";
export { ForwardRef as ReactComponent };